import React, { FC, useState } from "react";
import {
  IonButton,
  IonIcon,
  IonModal
} from '@ionic/react';

import {default as backgroundImage} from '../../../AE2/static/icons/hey_alpha/Hey Alphie Background.svg'
import {default as mascotIcon} from '../../../AE2/static/icons/hey_alpha/Alphie.svg';
import {default as leafIcon} from '../../../AE2/static/icons/hey_alpha/Leaf.svg';
import {default as resize_icon} from '../../../AE2/static/icons/hey_alpha/Expand Button.svg'
import {default as close_icon} from '../../../AE2/static/icons/hey_alpha/Close.svg'

import "./HeyAlphaModal.css"
import QuicksightQ from "../../../pages/AE2/QuicksightQ";
import { HEY_ALPHA_TOPIC_ID } from "../../../actions/settings";


interface IProps {
    isOpen: boolean;
onClose: () => void;
};

const HeyAlphaModal:FC<IProps> = ({isOpen,onClose}) => {
    const [size, setSize] = useState({
width: 1100,
height: 800
});

    const startResize = (e: React.MouseEvent) => {
    e.preventDefault();

    const startX = e.clientX;
    const startY = e.clientY;

    const startWidth = size.width;
    const startHeight = size.height;

    const handleMove = (moveEvent: MouseEvent) => {
      setSize({
        width: Math.max(
          900,
          startWidth + moveEvent.clientX - startX
        ),
        height: Math.max(
          600,
          startHeight + moveEvent.clientY - startY
        )
      });
    };

    const handleUp = () => {
      document.removeEventListener(
        'mousemove',
        handleMove
      );
      document.removeEventListener(
        'mouseup',
        handleUp
      );
    };

    document.addEventListener(
      'mousemove',
      handleMove
    );
    document.addEventListener(
      'mouseup',
      handleUp
    );
  };

  return (
    <IonModal
      isOpen={isOpen}
      className="alphie-modal"
      backdropDismiss={false}
    >
      <div
        className="alphie-container"
        style={{
          width: `${size.width}px`,
          height: `${size.height}px`,
        }}
      >
        <img className="alphie-background" src={backgroundImage} alt='background_img'/>

        <IonButton
          className="close-btn"
          fill="clear"
          size='small'
          onClick={onClose}
        >
          <IonIcon icon={close_icon} />
        </IonButton>

        <div className="left-panel">
          <h1>
            Hi, I'm <span>Alphie!</span>
          </h1>

          <p className="intro">
            I'm here to help you make the most of
            your energy performance dashboard
          </p>

          <p>
            Whether you're tracking savings,
            managing buildings, or exploring
            insights—I've got tips, tools, and
            answers for you.
          </p>

          <img src={mascotIcon} alt='alphie-icon' className="alphie"/>
        </div>

        <div className="content-panel">
          <QuicksightQ topicId={HEY_ALPHA_TOPIC_ID} />
        </div>

        <div className="footer-banner">
            <img src={leafIcon} alt='leaf-icon'/>

          <span>
            Together, we can build smarter,
            more sustainable communities.
          </span>
        </div>

        <div
          className="resize-handle"
          onMouseDown={startResize}
        >
            <img src={resize_icon} alt='resize-icon'/>
            </div>
      </div>
    </IonModal>
    )
};
export default HeyAlphaModal;